import { render, staticRenderFns } from "./channel-form.vue?vue&type=template&id=d5318082&scoped=true"
import script from "./channel-form.vue?vue&type=script&lang=js"
export * from "./channel-form.vue?vue&type=script&lang=js"
import style0 from "./channel-form.vue?vue&type=style&index=0&id=d5318082&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5318082",
  null
  
)

export default component.exports